module.exports = __webpack_public_path__ + "img/10.666941f6.png";